/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import apiLeaveMonitor from '@/services/jApiLeaveMonitor';

const state = {
  leave_employee_list: [],
};

const mutations = {
  setLeaveEmployee(state, payload) {
    state.leave_employee_list = payload;
  },
};

const actions = {
  async actionGetLeaveEmployee({ dispatch, commit }, data) {
    try {
      const res = await apiLeaveMonitor.getLeaveEmployee(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setLeaveEmployee', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetLeaveEmployeeByRestriction({ dispatch, commit }, data) {
    try {
      const res = await apiLeaveMonitor.getLeaveEmployeeByRestriction(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setLeaveEmployee', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreLeave.js